<template>
  <div class="purchase-material-list">
    <base-section-title v-if="!readOnly" title="采购清单" class="m-b-24">
      <template v-slot:right-tool>
        <template v-if="!hideConfig">
          <purchase-list-template-setting
            :no-default="noDefault"
            :read-only="readOnly"
            :item-schema-list="columnConfig"
            :purchase-type="purchaseType"
            @getColumnConfig="handleConfirmConfig"
          />
          <a-button class="m-r-10" @click="openImportDialog">
            采购清单导入
          </a-button>
        </template>
        <a-button type="danger" ghost @click="handleBatchDelete">
          批量删除
        </a-button>
      </template>
    </base-section-title>
    <el-table
      :class="table.length > size ? '' : 'm-b-24'"
      :data="pageMaterialList"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="!readOnly"
        key="selection"
        align="center"
        type="selection"
        width="60"
        fixed
      />
      <el-table-column
        key="index"
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
        fixed="left"
      />
      <el-table-column
        key="materielInfoConfig"
        label="品目信息"
        min-width="340px"
        fixed="left"
      >
        <template slot-scope="{ row }">
          <div
            v-for="item in materielInfoConfig"
            :key="item.defineCode"
            class="info-item"
          >
            <span class="info-item-label">{{ item.columnName || '-' }}</span>
            <span
              v-if="item.columnName === '分类' && row.categoryNameTree"
              class="info-item-value"
            >
              {{ row.categoryNameTree.join('>') || '-' }}
            </span>
            <span v-else class="info-item-value">
              {{ row[item.defineCode] || '-' }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        key="numConfig"
        label="采购量/计量单位"
        min-width="110px"
      >
        <template slot-scope="{ row }">
          <span>
            {{ row[numConfig.defineCode] }}/{{ row[unitConfig.defineCode] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="modelConfig.isEnable"
        key="modelConfig"
        label="参数型号"
      >
        <template slot-scope="{ row }">
          <span>{{ row[modelConfig.defineCode] || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        key="unitPriceConfig"
        :label="`预算单价(${isDollar ? '美元' : '元'})`"
        min-width="90px"
      >
        <template slot-scope="{ row }">
          <span>{{ row[unitPriceConfig.defineCode] || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        key="totalPrice"
        :label="`预算总价(${isDollar ? '美元' : '元'})`"
        min-width="90px"
      >
        <template slot-scope="{ row }">
          <span>{{ row.totalPrice || '-' }}</span>
          <money-in-cn v-if="!isDollar" :money="row.totalPrice || ''" />
        </template>
      </el-table-column>
      <el-table-column
        v-if="controlPriceConfig.isEnable"
        key="controlPriceConfig"
        :label="`控制价(${isDollar ? '美元' : '元'})`"
        min-width="90px"
      >
        <template slot-scope="{ row }">
          <span>{{ row.controlPrice || '-' }}</span>
          <money-in-cn v-if="!isDollar" :money="row.controlPrice || ''" />
        </template>
      </el-table-column>
      <el-table-column
        key="purchaseSpecifyConfig"
        label="采购人指定"
        min-width="340px"
      >
        <template v-if="purchaseSpecifyConfig.length > 0" slot-scope="{ row }">
          <div
            v-for="item in purchaseSpecifyConfig"
            :key="item.defineCode"
            class="info-item"
          >
            <span class="info-item-label">{{ item.columnName || '-' }}</span>
            <span class="info-item-value">
              {{ row[item.defineCode] || '-' }}
            </span>
          </div>
        </template>
        <template v-else>
          <span>-</span>
        </template>
      </el-table-column>
      <el-table-column
        key="supplierResponseConfig"
        label="供应商响应"
        min-width="340px"
      >
        <template v-if="supplierResponseConfig.length > 0">
          <div
            v-for="item in supplierResponseConfig"
            :key="item.defineCode"
            class="info-item"
          >
            <span class="info-item-label">{{ item.columnName || '-' }}</span>
            <span class="info-item-value">
              供应商响应，无需填写
            </span>
          </div>
        </template>
        <template v-else>
          <span>-</span>
        </template>
      </el-table-column>
      <el-table-column key="remarks" label="对供应商备注" min-width="100px">
        <template slot-scope="{ row }">
          <span>{{ row.remarks || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column key="insideRemark" label="内部备注" min-width="100px">
        <template slot-scope="{ row }">
          <span>{{ row.insideRemark || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column key="attachmentFileIds" label="附件" min-width="160px">
        <template slot-scope="{ row }">
          <upload
            v-if="row.attachmentFileIds && row.attachmentFileIds[0]"
            :props-data="{
              disabled: true,
              uploadMode: 'fileId',
              fileIdBefore: row.attachmentFileIds[0]
            }"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        key="operation"
        label="操作"
        min-width="120px"
        align="center"
        fixed="right"
      >
        <template slot-scope="{ row, $index }">
          <template v-if="!readOnly">
            <a-button type="link" @click="editPurchaseItem(row, $index)">
              编辑
            </a-button>
            <a-button
              type="link"
              class="text-danger"
              @click="removePurchaseItem(row, $index)"
            >
              删除
            </a-button>
          </template>
          <a-button v-else type="link" @click="lookDetail(row, $index)">
            查看详情
          </a-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增采购项 -->
    <div
      v-if="!readOnly"
      class="add-button m-b-24"
      @click="addPurchaseListItem"
    >
      <i class="el-icon-plus"></i>
      新增采购项
    </div>

    <pagination
      v-show="table.length > size"
      :total="table.length"
      size="small"
      :page.sync="page"
      :limit.sync="size"
    />

    <!-- 全部采购项总价汇总 -->
    <div class="total-price">
      <span class="total-price-label">全部采购项总价汇总：</span>
      <span class="total-price-value">{{ totalPrice | moneyFilter }}</span>
      <span>{{ isDollar ? '（美元）' : '' }}</span>
      <money-in-cn
        v-if="!isDollar"
        :money="totalPrice"
        style="display: inline-block"
        class="m-l-16"
      />
    </div>

    <!-- 新增采购项弹窗 -->
    <purchase-list-item
      v-model="purchaseListItemVisible"
      :info="currentRow"
      :config="columnConfig"
      :upload-params="uploadParams"
      :is-dollar="isDollar"
      :read-only="readOnly"
      @onConfirm="handleAddPurchaseItem"
    />

    <!-- 采购清单导入弹窗 -->
    <template-import-dialog
      ref="downloadAndUploadTemplatesDialog"
      v-model="importDialogVisible"
      @download="downloadTemplate"
      @upload="handleImport"
      @remove="removeFile"
      @confirm="confirmImport"
    />
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import PurchaseListItem from '@/components/common/PurchaseListComponent/PurchaseListItem'
import MoneyInCn from '@/components/common/MoneyInCn'
import Upload from '@/components/common/Upload'
import Pagination from '@/components/common/Pagination'
import PurchaseListTemplateSetting from '@/components/common/PurchaseListComponent/PurchaseListTemplateSetting.vue'
// import DownloadAndUploadTemplatesDialog from '@/components/common/PurchaseListComponent/DownloadAndUploadTemplatesDialog.vue'
import TemplateImportDialog from '@/components/common/TemplateImportDialog.vue'
// 工具
import { strToThousands } from '@/utils/utils'

import { importMaterialInfoDynamicApi } from '@/api/procure/inquiry'
import materialColumnMixin from '@/components/common/PurchaseListComponent/material-column-mixin'
import { cloneDeep, intersection } from 'lodash'
import {
  materialTemplateDefineTypeDict,
  materialTemplateKeyStatusDict
} from '@/dictionary/material/template'

/**
 * @description 采购人查看的采购清单
 */
export default {
  name: 'PurchaseList',

  filters: {
    moneyFilter(value) {
      return strToThousands(value)
    }
  },

  components: {
    BaseSectionTitle,
    PurchaseListItem,
    MoneyInCn,
    Upload,
    Pagination,
    PurchaseListTemplateSetting,
    TemplateImportDialog
  },

  mixins: [materialColumnMixin],

  props: {
    // 回显的表格数据
    tableData: {
      type: Array,
      default: () => []
    },

    // 是否只读
    readOnly: {
      type: Boolean,
      default: true
    },

    // 上传组件需要的定义参数
    uploadParams: {
      type: Object,
      default: () => {
        return {
          bizType: '',
          attachmentType: ''
        }
      }
    },

    // 外部传入的模板配置
    itemSchemaList: {
      type: Array,
      default: () => []
    },

    // 不选择默认模板
    noDefault: {
      type: Boolean,
      default: false
    },

    // 采购类型，目前支持询比和谈判采购
    purchaseType: {
      type: [String, Number],
      required: true
    },

    // 是否隐藏字段操作
    hideConfig: {
      type: Boolean,
      default: false
    },

    // 是否是美元模板
    isDollar: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // 控制新增采购项弹窗显示
      purchaseListItemVisible: false,

      // 控制采购清单导入弹窗显示
      importDialogVisible: false,

      // 已选择的采购项
      selectedRows: [],
      // 当前操作的采购项
      currentRow: {},
      // 当前操作的采购项下标
      currentRowIndex: -1,

      // 全部采购项总价
      totalPrice: 0,

      pageMaterialList: [], // 分页显示的列表
      page: 1,
      size: 10,

      // 导入的采购清单数据
      importMaterialList: []
    }
  },

  computed: {
    table: {
      get() {
        return this.tableData
      },
      set(val) {
        this.$emit('update:tableData', val)
      }
    }
  },

  watch: {
    table: {
      handler(val) {
        this.getPageData()
        this.getTotalPrice()
      },
      deep: true,
      immediate: true
    },

    itemSchemaList: {
      handler(val) {
        if (val.length > 0) {
          this.setColumnConfig(val)
        }
      },
      deep: true,
      immediate: true
    },

    size(val) {
      this.getPageData()
    },

    page(val) {
      this.getPageData()
    }
  },

  methods: {
    /**
     * 添加新的采购项
     */
    addPurchaseListItem() {
      console.log('columnConfig', this.columnConfig)
      this.currentRowIndex = -1
      this.currentRow = {}
      this.purchaseListItemVisible = true
    },

    /**
     * 编辑采购项
     */
    editPurchaseItem(row, index) {
      this.currentRow = row
      this.currentRowIndex = (this.page - 1) * this.size + index
      this.purchaseListItemVisible = true
    },

    /**
     * 删除采购项
     */
    removePurchaseItem(row, index) {
      this.$antConfirm({
        title: '是否确定删除该采购项',
        onOk: () => {
          this.table.splice(index, 1)
          this.$message.success('删除成功')
        }
      })
    },

    /**
     * 确定修改模板配置列表
     */
    handleConfirmConfig(columnConfig) {
      console.log('columnConfig>>>>>', columnConfig)
      // 同步字段列设置组件中的信息
      this.columnConfig = cloneDeep(columnConfig)
      this.setTableConfig()

      // 更换模板后，需要清空采购清单列表数据
      this.table = []
    },

    /**
     * 打开采购清单导入弹窗
     */
    openImportDialog() {
      this.importDialogVisible = true
    },

    /**
     * 添加或编辑采购项确定点击事件回调
     */
    handleAddPurchaseItem(form) {
      // 编辑操作
      if (this.currentRowIndex > -1) {
        this.$set(this.table, this.currentRowIndex, form)
        return
      }

      // 新增操作
      this.table.push(form)
    },

    /**
     * 处理采购清单表格勾选
     */
    handleSelectionChange(rows) {
      this.selectedRows = rows
    },

    /**
     * 批量删除
     */
    handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.info('请选择要删除的采购项')
        return
      }

      this.$antConfirm({
        title: '是否确认删除当前选择的采购项',
        onOk: () => {
          // 获取已选项在品目列表中的下标
          const indexArray = this.selectedRows.map(s =>
            this.table.findIndex(t => t === s)
          )
          // 根据已选项的下标排除数据，返回未选的品目数据
          const tempArray = this.table.filter(
            (v, index) => !indexArray.includes(index)
          )
          // 将未选的品目数据覆盖写入原本的品目表，达到批量删除的目的
          this.table = [...tempArray]
          this.$message.success('删除成功')
        }
      })
    },

    /**
     * 执行本地的总金额计算
     */
    getTotalPrice() {
      let fee = 0

      if (this.table.length === 0) {
        this.totalPrice = fee.toFixed(2)
        // if (this.readOnly) {
        //   this.$emit('getTotalFee', this.totalPrice)
        // }
        this.$emit('getTotalFee', this.totalPrice)
        return false
      }

      this.table.forEach(val => {
        if (val.totalPrice) fee = fee + Number(val.totalPrice) * 100
      })

      this.totalPrice = (Math.round(fee) / 100).toFixed(2)
      // if (this.readOnly) {
      //   this.$emit('getTotalFee', this.totalPrice)
      // }
      this.$emit('getTotalFee', this.totalPrice)
    },

    /**
     * 查看采购项详情
     */
    lookDetail(row, index) {
      this.currentRowIndex = index
      this.currentRow = row
      this.purchaseListItemVisible = true
    },

    /**
     * 下载动态模板
     */
    downloadTemplate() {
      // 先保存获取orderId后再进行下载
      this.$emit('downloadTemplate')
    },

    // 批量导入
    handleImport(file) {
      this.importMaterialList = []
      importMaterialInfoDynamicApi({ file }, { headRowNumber: 2 })
        .then(res => {
          // 是否使用了不同模板
          const DIFF_CONFIG = !this.validTemplateSame(res.data?.attrList)
          if (DIFF_CONFIG) {
            this.$refs.downloadAndUploadTemplatesDialog.removeFile()
            return
          }

          // 存在值错误字段
          let hasValueError = false
          // 存在必填项错误
          let hasRequireError = false
          const VALUE_TRANS_LIST = (res.data?.valueList || []).map(item => {
            const VALUE_TRANS = {}
            // 导入数据中，key为字段模板中对应的columnName，根据key指定value的归属字段
            // eslint-disable-next-line no-unused-vars
            for (const key in item) {
              const CONFIG_ITEM = this.columnConfig.find(
                t => t.columnName === key
              )

              // 针对数量和预算单价做限制校验
              if (
                key === this.unitPriceConfig.columnName ||
                key === this.numConfig.columnName
              ) {
                if (!this.validNumAndUnitPrice(item, key)) {
                  hasValueError = true
                  break
                }
                VALUE_TRANS[CONFIG_ITEM.defineCode] = item[key]
                continue
              }
              // 控制价限制校验
              if (
                key === this.controlPriceConfig.columnName &&
                this.controlPriceConfig.isEnable
              ) {
                if (!this.validNumAndUnitPrice(item, key)) {
                  hasValueError = true
                  break
                }
                VALUE_TRANS[CONFIG_ITEM.defineCode] = item[key]
                continue
              }
              // 针对对供应商备注和内部备注做特殊处理
              if (key === '对供应商备注') {
                if (!this.validTextLength(item, key)) {
                  hasValueError = true
                  break
                }
                VALUE_TRANS.remarks = item[key]
                continue
              }
              if (key === '内部备注') {
                if (!this.validTextLength(item, key)) {
                  hasValueError = true
                  break
                }
                VALUE_TRANS.insideRemark = item[key]
                continue
              }
              // 如果没找到对应的defineCode，则直接进入下一项的遍历
              if (!CONFIG_ITEM?.defineCode) {
                continue
              }
              // 其余普通字段，只需要校验长度不超过200
              if (!this.validTextLength(item, key, 200)) {
                hasValueError = true
                break
              }
              VALUE_TRANS[CONFIG_ITEM.defineCode] = item[key]
            }
            const HAS_MISSING = !this.validPurchaseItemRequire(VALUE_TRANS)
            if (HAS_MISSING && !hasRequireError && !hasValueError) {
              hasValueError = true
              hasRequireError = true
              this.$antWarning({
                title: '操作提示',
                content: `采购清单表格中包含的必填项品目名称、采购量、计量单位、预算单价${
                  this.controlPriceConfig.isEnable
                    ? `、${this.controlPriceConfig.columnName}`
                    : ''
                }字段为空或采购量和预算单位为零，请检查后发布`,
                onOk: () => this.$antModalDestroyAll()
              })
            } else {
              // 所有必填项均已填写之后，计算预算总价
              const TOTAL_PRICE = Number(
                (
                  (VALUE_TRANS[this.numConfig.defineCode] *
                    100 *
                    (VALUE_TRANS[this.unitPriceConfig.defineCode] * 100)) /
                  10000
                ).toFixed(2)
              )
              VALUE_TRANS.totalPrice = isNaN(TOTAL_PRICE) ? 0 : TOTAL_PRICE
            }
            return VALUE_TRANS
          })
          if (hasValueError) {
            this.$refs.downloadAndUploadTemplatesDialog.removeFile()
          } else {
            this.importMaterialList = VALUE_TRANS_LIST
          }
        })
        .catch(err => {
          this.$message.error(err.message || '导入失败')
        })
    },

    /**
     * 检查上传的文件是否与模板相同
     */
    validTemplateSame(attrList) {
      // 判断导入的表头和模板字段设置(需排除供应商响应字段)是否相符
      const ATTR_LIST = (attrList || []).map(item => item.attrName) || []
      const CONFIG_NAME_LIST =
        this.columnConfig
          .filter(
            item =>
              item.defineType !==
                materialTemplateDefineTypeDict.RESPONSE.value &&
              item.isEnable === materialTemplateKeyStatusDict.OPENED.value
          )
          .map(item => item.columnName) || []
      // 通过获取字段配置表与导入表头的交集长度，是否等于导入表头长度，来判断是否使用相同的模板
      const INTERSECTION_LIST = intersection(ATTR_LIST, CONFIG_NAME_LIST) || []
      // 是否使用了不同模板(如果交集长度大于设置长度，则视为不同，否则相同)
      const DIFF_CONFIG = INTERSECTION_LIST.length > CONFIG_NAME_LIST.length
      if (DIFF_CONFIG) {
        this.$antWarning({
          content: '上传的文件数据有误或模板不匹配，请重新上传',
          title: '操作提示',
          onOk: () => this.$antModalDestroyAll()
        })
        return false
      }
      return true
    },

    /**
     * 检查采购项中的必填项值是否都存在
     */
    validPurchaseItemRequire(obj) {
      // 判断nameConfig、numConfig、unitConfig和unitPriceConfig都必须有值
      const REQUIRE_KEY_LIST = [
        this.nameConfig,
        this.numConfig,
        this.unitConfig,
        this.unitPriceConfig,
        this.controlPriceConfig.isEnable ? this.controlPriceConfig : undefined
      ]
        .filter(value => value)
        .map(item => item.defineCode)
      return !REQUIRE_KEY_LIST.some(
        key => obj[key] == undefined || obj[key] == null
      )
    },

    /**
     * 检查数量和预算单价
     */
    validNumAndUnitPrice(item, key) {
      const VALUE = Number(item[key])
      if (!VALUE) {
        this.$antWarning({
          title: '操作提示',
          content:
            '采购清单表格中包含的必填项品目名称、数量、单位、预算单价字段为空或数量和预算单位为零，请检查后发布',
          onOk: () => this.$antModalDestroyAll()
        })
        return false
      }
      if (isNaN(VALUE)) {
        this.$antWarning({
          title: '操作提示',
          content: `"${
            item[this.nameConfig.columnName]
          }" 的 “${key}” 填写错误，请填写数字后上传`,
          onOk: () => this.$antModalDestroyAll()
        })
        return false
      }
      if (item[key]?.length > 11) {
        this.$antWarning({
          title: '操作提示',
          content: `"${
            item[this.nameConfig.columnName]
          }" 的 “${key}” 填写错误，请填写小于11位数的数字后上传`,
          onOk: () => this.$antModalDestroyAll()
        })
        return false
      }
      return true
    },

    /**
     * 校验文本长度
     */
    validTextLength(item, key, limit = 500) {
      if (item[key]?.length > limit) {
        this.$antWarning({
          title: '操作提示',
          content: `"${
            item[this.nameConfig.columnName]
          }" 的 “${key}” 字段超出${limit}字限制，请修改后上传`,
          onOk: () => this.$antModalDestroyAll()
        })
        return false
      }
      return true
    },

    /**
     * 删除导入数据
     */
    removeFile() {
      this.importMaterialList = []
    },

    /**
     * 确认导入
     */
    confirmImport() {
      this.table = this.importMaterialList
      this.getPageData()
    },

    /**
     * @description: 前端分页，获取当前页数据
     */
    getPageData() {
      const start = (this.page - 1) * this.size
      const end = start + this.size
      this.pageMaterialList = this.table.slice(start, end)
    }
  }
}
</script>

<style lang="scss" scoped>
.cell-item {
  border: 1px solid $info-fourth-color;
}

.add-button {
  width: 100%;
  height: 32px;
  line-height: 32px;
  border: 1px dashed $primary-color;
  text-align: center;
  color: $primary-color;
  cursor: pointer;
  margin-top: 16px;
}

.info-item {
  display: flex;
  align-items: stretch;
  margin: 24px 0;
  line-height: 22px;

  &:first-child {
    margin-top: 16px;
  }
  &:last-child {
    margin-bottom: 16px;
  }

  .info-item-label {
    color: $text-color;
    width: 40%;
    margin-right: 24px;
    font-weight: bold;
  }
  .info-item-value {
    flex: 1;
    color: $second-text-color;
  }
}

// 采购清单导入弹窗样式
.import-dialog {
  ::v-deep .ant-modal-body {
    padding: 40px 24px;
  }

  .import-dialog-body {
    display: flex;
    align-items: stretch;

    .body-section {
      flex: 1;

      .body-section-title {
        font-size: 16px;
        color: $text-color;
        font-weight: bold;

        .body-section-title_index {
          display: inline-block;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          font-weight: normal;
          color: $white-color;
          background-color: $primary-color;
          text-align: center;
          line-height: 22px;
          margin-right: 4px;
        }
      }

      .body-section-content {
        width: 100%;
        border: 2px dashed $info-third-color;
        border-radius: 4px;
        padding: 30px 16px;
        text-align: center;
        margin-top: 32px;

        p {
          color: $text-color;
        }
      }
    }
  }
}

.total-price {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  background-color: $info-fifth-color;
  padding: 0 16px;

  .total-price-label {
    color: $second-text-color;
    font-size: 14px;
  }

  .total-price-value {
    color: $text-color;
    font-size: 16px;
  }
}
</style>
